/* Fall sale behaviour on the product page.
   1. Keeps the struck list price and the % badge correct when the shopper
      changes variant. The theme rewrites [data-price] from the product JSON,
      where compare_at_price is null on nearly every variant, so the badge
      would vanish on the first colour change. A MutationObserver recomputes
      from the sitewide sale depth instead of forking the variant script.
   2. Drives the multi-buy tiers: sets the form quantity to the UNIT count so
      Shopify's Buy X Get Y discount has something to take the free unit from.
      The tier radios live inside the product form, so their change event is
      stopped before it reaches the theme's variant listener, and a
      MutationObserver re-asserts the tier price if anything rewrites the
      button (theme.js replaces its label while the add request is in flight).
      The saving is written into its own element so it can be coloured.
   Money is reformatted from the shape of the price already on the page, so
   this keeps working in every currency the store sells in.
   List prices land on .95, and the saved percentage is floored so the badge
   never claims a bigger discount than the two prices beside it show. */
(function () {
  'use strict';

  var ENDING = 95;

  function shape(sample) {
    var s = String(sample || '').trim();
    var m = s.match(/([0-9][0-9.,\s]*)/);
    if (!m) { return { pre: '$', post: '', dec: '.', group: ',' }; }
    var num = m[1];
    var i = s.indexOf(num);
    var lastDot = num.lastIndexOf('.');
    var lastCom = num.lastIndexOf(',');
    var dec = lastCom > lastDot ? ',' : '.';
    return {
      pre: s.slice(0, i),
      post: s.slice(i + num.length),
      dec: dec,
      group: dec === ',' ? '.' : ','
    };
  }

  function toCents(sample) {
    var f = shape(sample);
    var m = String(sample).match(/([0-9][0-9.,\s]*)/);
    if (!m) { return 0; }
    var raw = m[1].replace(/\s/g, '');
    if (f.group) { raw = raw.split(f.group).join(''); }
    if (f.dec !== '.') { raw = raw.split(f.dec).join('.'); }
    var v = parseFloat(raw);
    return isNaN(v) ? 0 : Math.round(v * 100);
  }

  function fmt(cents, f) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.group);
    return f.pre + whole + f.dec + parts[1] + f.post;
  }

  function listPrice(cents, pct) {
    if (!pct || pct <= 0 || cents <= 0) { return 0; }
    var raw = Math.round((cents * 100) / (100 - pct));
    var whole = Math.floor(raw / 100);
    var nice = whole * 100 + ENDING;
    if (nice <= cents) { nice = (whole + 1) * 100 + ENDING; }
    return nice;
  }

  var blocks = document.querySelectorAll('[data-price-block]');
  for (var b = 0; b < blocks.length; b++) {
    (function (block) {
      var pct = parseInt(block.getAttribute('data-sale-pct'), 10) || 0;
      var nowEl = block.querySelector('[data-price]');
      var cmpEl = block.querySelector('[data-compare-price]');
      var saveEl = block.querySelector('[data-save]');
      if (!nowEl || !cmpEl || !saveEl) { return; }
      var f = shape(nowEl.textContent);

      function sync() {
        var cents = toCents(nowEl.textContent);
        if (!cents) { return; }
        var list = listPrice(cents, pct);
        if (list > cents) {
          cmpEl.textContent = fmt(list, f);
          cmpEl.removeAttribute('hidden');
          saveEl.textContent = Math.floor(((list - cents) / list) * 100) + '% off';
          saveEl.removeAttribute('hidden');
        } else {
          cmpEl.setAttribute('hidden', '');
          saveEl.setAttribute('hidden', '');
        }
        document.dispatchEvent(new CustomEvent('qc:unit-price', { detail: { cents: cents } }));
      }

      new MutationObserver(sync).observe(nowEl, { childList: true, characterData: true, subtree: true });
      sync();
    })(blocks[b]);
  }

  var wraps = document.querySelectorAll('[data-qty-tiers]');
  for (var w = 0; w < wraps.length; w++) {
    (function (wrap) {
      var tiers = Array.prototype.slice.call(wrap.querySelectorAll('[data-tier]'));
      if (!tiers.length) { return; }
      var form = wrap.closest('form');
      var qtyInput = form ? form.querySelector('[data-qty]') : null;
      var btn = form ? form.querySelector('[data-add-to-cart]') : null;
      var sampleEl = document.querySelector('[data-price-block] [data-price]');
      var f = shape(sampleEl ? sampleEl.textContent : '$0.00');
      var unit = parseInt(wrap.getAttribute('data-unit'), 10) || 0;
      var wantText = '';
      var writing = false;

      /* Keep the tier radios to ourselves. The theme listens for change on the
         product form; without this it treats a tier click as a variant change. */
      wrap.addEventListener('change', function (e) { e.stopPropagation(); }, false);
      wrap.addEventListener('input', function (e) { e.stopPropagation(); }, false);

      function writeBtn(text) {
        if (!btn || !text) { return; }
        var el = btn.querySelector('[data-price-btn]');
        if (!el) {
          el = document.createElement('span');
          el.setAttribute('data-price-btn', '');
          btn.appendChild(el);
        }
        if (el.textContent !== text) {
          writing = true;
          el.textContent = text;
          writing = false;
        }
      }

      if (btn && window.MutationObserver) {
        new MutationObserver(function () {
          if (!writing) { writeBtn(wantText); }
        }).observe(btn, { childList: true, characterData: true, subtree: true });
      }

      function paidFor(units) {
        if (units === 3) { return 2; }
        if (units === 5) { return 3; }
        return 1;
      }

      function apply() {
        var active = wrap.querySelector('[data-tier].is-active') || tiers[0];
        var units = parseInt(active.getAttribute('data-units'), 10) || 1;
        var pay = parseInt(active.getAttribute('data-pay'), 10) || unit;
        if (qtyInput) { qtyInput.value = units; }
        wantText = fmt(pay, f);
        writeBtn(wantText);
      }

      function repaint() {
        for (var i = 0; i < tiers.length; i++) {
          var t = tiers[i];
          var units = parseInt(t.getAttribute('data-units'), 10) || 1;
          var paid = paidFor(units);
          var pay = unit * paid;
          t.setAttribute('data-pay', pay);
          var each = t.querySelector('[data-each]');
          var saved = t.querySelector('[data-save-amt]');
          var total = t.querySelector('[data-total]');
          if (total) { total.textContent = fmt(pay, f); }
          if (each) {
            each.textContent = fmt(units === 1 ? unit : Math.round(pay / units), f) + ' each';
          }
          if (saved) {
            if (units === 1) {
              saved.hidden = true;
            } else {
              saved.textContent = 'Save ' + fmt(unit * (units - paid), f);
              saved.hidden = false;
            }
          }
        }
        apply();
      }

      for (var k = 0; k < tiers.length; k++) {
        (function (t) {
          t.addEventListener('click', function () {
            for (var j = 0; j < tiers.length; j++) { tiers[j].classList.remove('is-active'); }
            t.classList.add('is-active');
            var r = t.querySelector('input');
            if (r) { r.checked = true; }
            apply();
          });
        })(tiers[k]);
      }

      document.addEventListener('qc:unit-price', function (e) {
        if (e.detail && e.detail.cents) {
          unit = e.detail.cents;
          repaint();
        }
      });

      repaint();
    })(wraps[w]);
  }
})();
